import styled from 'styled-components';
import PasswordField from './PasswordField';
import { colorSchema } from 'utils/style';

export default styled(PasswordField)`
  .password-field {
    display: flex;
    position: relative;

    &__action {
      background: none;
      border: 0;
      color: ${colorSchema('grey500')};
      cursor: pointer;
      font-size: 1rem;
      font-weight: 500;
      outline: 0;
      position: absolute;
      right: 20px;
      text-transform: uppercase;
      top: 17px;
      z-index: 2;
    }
  }
`;
